import styled from "styled-components";
import Search from "shared/components/Search";
import { useNavigate } from "react-router-dom";
import usePreviewBranch from "features/owner/hooks/usePreviewBranch";
import { hw } from "features/homework/homeworkUi";

const PreviewBranch = () => {
    const navigate = useNavigate();
    const { search, searchedLists, onChange } = usePreviewBranch();

    if (!searchedLists.length && !search) {
        return (
            <Container>
                <Search placeholder="지점을 검색해 주세요" value={search} onChange={onChange} />
                <Empty>등록된 지점이 없습니다.</Empty>
            </Container>
        );
    }

    return (
        <Container>
            <Search placeholder="지점을 검색해 주세요" value={search} onChange={onChange} />
            {searchedLists.length ? (
                <BranchWrap>
                    {searchedLists.map((item) => (
                        <BranchItem
                            key={item.id}
                            type="button"
                            onClick={() => navigate("/owner/branch/register", { state: item.id })}
                        >
                            <Name>{item.name}</Name>
                            <Hint>상세 보기</Hint>
                        </BranchItem>
                    ))}
                </BranchWrap>
            ) : (
                <Empty>검색 결과가 없습니다.</Empty>
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    min-height: 0;
`;

const BranchWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    min-height: 0;
    overflow: auto;
`;

const BranchItem = styled.button`
    appearance: none;
    border: 1px solid ${hw.border};
    background: ${hw.bg};
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    text-align: left;
    width: 100%;

    &:hover {
        background: ${hw.brandSoft};
        border-color: ${hw.brandMuted};
    }
`;

const Name = styled.span`
    font-size: 15px;
    font-weight: 700;
    color: ${hw.text};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const Hint = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${hw.brand};
    flex-shrink: 0;
`;

const Empty = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 8px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`;

export default PreviewBranch;
